(function () {
  "use strict";
  
  const popups = document.querySelectorAll(".gift-popup");
  if (!popups.length) return;

  /* ---------------------------
    Confetti effect (optimized)
  --------------------------- */
  function createConfetti() {
    const container = document.createElement("div");
    container.className = "gift-confetti";
    document.body.appendChild(container);

    const colors = ["#ff6b6b", "#feca57", "#48dbfb", "#ff9ff3", "#54a0ff", "#5f27cd", "#00d2d3", "#ff9f43"];
    const pieceCount = 50;

    for (let i = 0; i < pieceCount; i++) {
      const piece = document.createElement("div");
      piece.className = "gift-confetti__piece";
      
      const color = colors[i % colors.length];
      const size = 6 + (i % 5) * 2;
      const left = (i * 2) % 100;
      const delay = (i % 10) * 0.05;
      const duration = 2 + (i % 3);

      piece.style.cssText = `left:${left}%;width:${size}px;height:${size}px;background-color:${color};animation-delay:${delay}s;animation-duration:${duration}s;border-radius:${i % 2 === 0 ? '50%' : '0'}`;
      container.appendChild(piece);
    }

    setTimeout(() => container.remove(), 4000);
  }

  /* ---------------------------
    Cookie helpers
  --------------------------- */
  function setCookie(name, value, days) {
    const d = new Date();
    d.setTime(d.getTime() + days * 86400000);
    document.cookie = name + "=" + encodeURIComponent(value) + "; expires=" + d.toUTCString() + "; path=/; SameSite=Lax";
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
    return match ? decodeURIComponent(match[2]) : null;
  }

  /* ---------------------------
    Cart helpers
  --------------------------- */
  async function fetchCart() {
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) throw new Error("Cart fetch failed");
    return res.json();
  }

  async function addVariantToCart(variantId) {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _addedFromGiftPopup: "true" } }]
      })
    });
    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  }

  async function removeLineByKey(lineKey) {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: lineKey, quantity: 0 })
    });
    if (!res.ok) throw new Error("Remove line failed");
    return res.json();
  }

  function collectGiftProductIds(popup) {
    const ids = new Set();
    popup.querySelectorAll("[data-gift-product]").forEach((el) => {
      const id = Number(el.dataset.giftProductId);
      if (id) ids.add(id);
    });
    return Array.from(ids);
  }

  function isAnyGiftInCart(cart, giftProductIds) {
    const items = cart?.items || [];
    return items.some((it) => giftProductIds.includes(Number(it.product_id)));
  }

  function qualifyingTotalCents(cart, giftProductIds) {
    const items = cart?.items || [];
    return items.reduce((sum, it) => {
      if (!giftProductIds.includes(Number(it.product_id))) {
        sum += Number(it.final_line_price || 0);
      }
      return sum;
    }, 0);
  }

  /* ---------------------------
    Cart change notifications
  --------------------------- */
  const LISTENERS_KEY = "__giftPopupListeners";
  const TIMER_KEY = "__giftPopupTimer";
  window[LISTENERS_KEY] = window[LISTENERS_KEY] || new Set();

  function notifyListeners() {
    clearTimeout(window[TIMER_KEY]);
    window[TIMER_KEY] = setTimeout(() => {
      window[LISTENERS_KEY].forEach((fn) => { try { fn(); } catch (_) {} });
    }, 100);
  }

  if (!window.__giftPopupSetupDone) {
    window.__giftPopupSetupDone = true;

    const tryObserveDrawer = () => {
      const drawer = document.querySelector("cart-drawer, #cart-drawer, [data-cart-drawer], .cart-drawer");
      if (!drawer) return false;
      new MutationObserver(notifyListeners).observe(drawer, { subtree: true, childList: true });
      return true;
    };

    if (!tryObserveDrawer()) {
      let attempts = 0;
      const iv = setInterval(() => {
        if (tryObserveDrawer() || ++attempts > 15) clearInterval(iv);
      }, 500);
    }

    ["cart:updated", "cart:refresh", "theme:cart:updated", "theme:cart:refresh", "ajaxCart:afterAdd", "ajaxCart:afterUpdate"]
      .forEach((ev) => document.addEventListener(ev, notifyListeners, true));

    document.addEventListener("click", (e) => {
      const el = e.target;
      if (!(el instanceof Element)) return;
      const atc = el.closest('button[name="add"], [data-action="add-to-cart"], [data-add-to-cart]');
      if (atc) {
        setTimeout(notifyListeners, 400);
        setTimeout(notifyListeners, 900);
      }
    }, true);

    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        document.querySelectorAll(".gift-popup:not([hidden])").forEach((p) => {
          p.hidden = true;
          p.setAttribute("aria-hidden", "true");
        });
      }
    });
  }

  /* ---------------------------
    Floating button
  --------------------------- */
  function ensureGiftFab(popup, onClick) {
    const popupId = popup.dataset.popupId || "default";
    const position = popup.dataset.fabPosition || "right";
    const id = "gift-fab-" + popupId;

    let btn = document.getElementById(id);
    if (btn) return btn;

    btn = document.createElement("button");
    btn.type = "button";
    btn.id = id;
    btn.className = "gift-fab gift-fab--" + position;
    btn.setAttribute("aria-label", "בחר מתנה");
    btn.innerHTML = '<span class="gift-fab__icon">🎁</span><span class="gift-fab__badge">1</span>';
    btn.addEventListener("click", onClick);
    document.body.appendChild(btn);
    return btn;
  }

  function removeGiftFab(popup) {
    const id = "gift-fab-" + (popup.dataset.popupId || "default");
    const el = document.getElementById(id);
    if (el) el.remove();
  }

  /* ---------------------------
    Color helpers
  --------------------------- */
  const COLOR_MAP = {
    black: "#0f0f10", white: "#ffffff", beige: "#e7d8c6", cream: "#f3f0e7",
    brown: "#6b4f3b", gray: "#9aa0a6", grey: "#9aa0a6", red: "#d81f26", 
    pink: "#f3a6b9", blue: "#1f4bd8", navy: "#0b1b3b", green: "#1f7a3a", 
    gold: "#c9a227", silver: "#c0c0c0", nude: "#e3c4b1", camel: "#c19a6b",
    olive: "#808000", orange: "#ff6600", purple: "#800080", yellow: "#f0c000",
    burgundy: "#800020", coral: "#ff7f50", turquoise: "#40e0d0", charcoal: "#36454f"
  };

  const COLOR_MAP_HE = {
    "שחור": "#0f0f10", "לבן": "#ffffff", "שמנת": "#f3f0e7", "בז׳": "#e7d8c6",
    "בז'": "#e7d8c6", "חום": "#6b4f3b", "אפור": "#9aa0a6", "אדום": "#d81f26",
    "ורוד": "#f3a6b9", "כחול": "#1f4bd8", "ירוק": "#1f7a3a", "זהב": "#c9a227",
    "כסף": "#c0c0c0", "נייבי": "#0b1b3b", "סגול": "#800080", "צהוב": "#f0c000",
    "כתום": "#ff6600", "בורדו": "#800020"
  };

  function getColorValue(name) {
    const lower = String(name || "").trim().toLowerCase();
    if (/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(lower)) return lower;
    if (COLOR_MAP[lower]) return COLOR_MAP[lower];
    if (COLOR_MAP_HE[name]) return COLOR_MAP_HE[name];
    for (const k in COLOR_MAP) { if (lower.includes(k)) return COLOR_MAP[k]; }
    for (const k in COLOR_MAP_HE) { if (String(name).includes(k)) return COLOR_MAP_HE[k]; }
    return "#d7d7d7";
  }

  function isColorOption(name) {
    const n = String(name || "").toLowerCase();
    return n.includes("color") || n.includes("colour") || n.includes("צבע");
  }

  function isSizeOption(name) {
    const n = String(name || "").toLowerCase();
    return n.includes("size") || n.includes("מידה");
  }

  function getOptionName(opt, idx) {
    if (typeof opt === "string") return opt;
    if (opt && opt.name) return opt.name;
    return "Option " + (idx + 1);
  }

  /* ---------------------------
    Variant pickers
  --------------------------- */
  function buildVariantPickers(product, container, msgEl, onSelect, onImageChange) {
    container.innerHTML = "";
    
    const options = product?.options || [];
    const variants = product?.variants || [];
    
    const setMsg = function(t) { if (msgEl) msgEl.textContent = t || ""; };

    if (!options.length) {
      const first = variants[0];
      onSelect(first ? first.id : null);
      if (typeof onImageChange === "function") onImageChange(first || null);
      return;
    }

    const chosen = new Array(options.length).fill("");
    
    const valuesByOption = options.map(function(_, i) {
      const set = new Set();
      variants.forEach(function(v) {
        const val = v?.options?.[i];
        if (val) set.add(val);
      });
      return Array.from(set);
    });

    function isAvailable(optIdx, value) {
      return variants.some(function(v) {
        if (!v?.available || v.options?.[optIdx] !== value) return false;
        return chosen.every(function(c, i) { return i === optIdx || !c || v.options[i] === c; });
      });
    }

    function getFullMatch() {
      if (chosen.some(function(v) { return !v; })) return null;
      return variants.find(function(v) { 
        return v?.available && v.options?.every(function(o, i) { return o === chosen[i]; }); 
      }) || null;
    }

    function getPartialMatch() {
      return variants.find(function(v) {
        if (!v?.available) return false;
        return chosen.every(function(c, i) { return !c || v.options?.[i] === c; });
      }) || null;
    }

    function update() {
      const full = getFullMatch();
      const partial = getPartialMatch();
      if (typeof onImageChange === "function") onImageChange(partial);
      if (full) {
        onSelect(full.id);
        if (msgEl && msgEl.textContent && msgEl.textContent.includes("לא זמין")) setMsg("");
      } else {
        onSelect(null);
        if (chosen.every(function(c) { return c; })) setMsg("הווריאנט שבחרת לא זמין");
      }
    }

    function render() {
      container.innerHTML = "";
      
      options.forEach(function(opt, optIdx) {
        const name = getOptionName(opt, optIdx);
        const values = valuesByOption[optIdx];
        const kind = isColorOption(name) ? "color" : (isSizeOption(name) ? "size" : "other");

        const wrap = document.createElement("div");
        const label = document.createElement("label");
        label.textContent = name;
        wrap.appendChild(label);

        const row = document.createElement("div");
        row.className = "gift-swatch-row";

        values.forEach(function(val) {
          const btn = document.createElement("button");
          btn.type = "button";
          btn.className = "gift-swatch";
          btn.disabled = !isAvailable(optIdx, val);
          if (chosen[optIdx] === val) btn.classList.add("is-active");

          if (kind === "color") {
            const dot = document.createElement("span");
            dot.className = "gift-swatch__dot";
            
            const variantWithImage = variants.find(function(v) {
              return v.options?.[optIdx] === val && v.featured_image && v.featured_image.src;
            });
            
            if (variantWithImage && variantWithImage.featured_image && variantWithImage.featured_image.src) {
              dot.style.backgroundImage = "url(" + variantWithImage.featured_image.src + ")";
              dot.style.backgroundSize = "cover";
              dot.style.backgroundPosition = "center";
            } else {
              dot.style.background = getColorValue(val);
            }
            btn.appendChild(dot);
          }

          const txt = document.createElement("span");
          txt.className = "gift-swatch__text";
          txt.textContent = val;
          btn.appendChild(txt);

          btn.addEventListener("click", function() {
            chosen[optIdx] = chosen[optIdx] === val ? "" : val;
            chosen.forEach(function(c, i) {
              if (c && !isAvailable(i, c)) chosen[i] = "";
            });
            render();
            update();
          });

          row.appendChild(btn);
        });

        wrap.appendChild(row);
        container.appendChild(wrap);
      });
    }

    render();
    update();
  }

  /* ---------------------------
    Tabs
  --------------------------- */
  function setupTabs(popup, cards) {
    const content = popup.querySelector(".gift-popup__content");
    if (!content || cards.length < 2) {
      if (cards[0]) cards[0].classList.add("is-active");
      return;
    }

    let tabs = content.querySelector(".gift-tabs");
    if (tabs && tabs.dataset.ready === "1") return;

    if (!tabs) {
      tabs = document.createElement("div");
      tabs.className = "gift-tabs";
      const textEl = content.querySelector(".gift-popup__text");
      content.insertBefore(tabs, textEl ? textEl.nextSibling : content.firstChild);
    }

    tabs.dataset.ready = "1";
    tabs.innerHTML = "";

    cards.forEach(function(card, idx) {
      const titleEl = card.querySelector(".gift-product__title");
      const title = titleEl ? titleEl.textContent.trim() : "מתנה " + (idx + 1);
      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "gift-tab";
      btn.textContent = title;
      
      btn.addEventListener("click", function() {
        cards.forEach(function(c, i) { c.classList.toggle("is-active", i === idx); });
        tabs.querySelectorAll(".gift-tab").forEach(function(b, i) { b.classList.toggle("is-active", i === idx); });
      });
      
      tabs.appendChild(btn);
    });

    if (cards[0]) cards[0].classList.add("is-active");
    const firstTab = tabs.querySelector(".gift-tab");
    if (firstTab) firstTab.classList.add("is-active");
  }

  /* ---------------------------
    Init popup
  --------------------------- */
  function initPopup(popup) {
    const popupId = popup.dataset.popupId || "default";
    const delaySeconds = Number(popup.dataset.delaySeconds) || 0;
    const autoOpen = popup.dataset.autoOpen === "true";
    const showOnce = popup.dataset.showOnce === "true";
    const cookieDays = Number(popup.dataset.cookieDays) || 1;
    const threshold = Number(popup.dataset.cartThreshold) || 149;
    
    const COOKIE_NAME = "gift_popup_" + popupId;
    const SESSION_KEY = "gift_eligible_" + popupId;
    
    const giftIds = collectGiftProductIds(popup);
    if (!giftIds.length) return;

    var opening = false;
    const productCache = new Map();

    function close() {
      popup.hidden = true;
      popup.setAttribute("aria-hidden", "true");
    }

    function getPrevEligible() {
      try { return sessionStorage.getItem(SESSION_KEY) === "1"; } catch (_) { return false; }
    }
    
    function setPrevEligible(v) {
      try { sessionStorage.setItem(SESSION_KEY, v ? "1" : "0"); } catch (_) {}
    }

    function isEligible(cart) {
      const total = qualifyingTotalCents(cart, giftIds);
      return total >= threshold * 100 && !isAnyGiftInCart(cart, giftIds);
    }

    // Disabled: No longer auto-removing gifts when cart drops below threshold
    // The discounts app handles returning the product to full price
    async function removeGiftsIfNotEligible(cart) {
      return; // Do nothing - disabled
    }

    async function getProduct(handle) {
      if (productCache.has(handle)) return productCache.get(handle);
      const res = await fetch("/products/" + handle + ".js", { credentials: "same-origin" });
      if (!res.ok) throw new Error("Product fetch failed");
      const data = await res.json();
      productCache.set(handle, data);
      return data;
    }

    popup.querySelectorAll("[data-gift-popup-close]").forEach(function(el) {
      el.addEventListener("click", close);
    });

    function openManually() {
      popup.hidden = false;
      popup.setAttribute("aria-hidden", "false");
      createConfetti();
      initCards().catch(function() {});
    }

    async function maybeAutoOpen(eligible) {
      if (!autoOpen || opening || getPrevEligible() || !eligible) return;
      if (showOnce && getCookie(COOKIE_NAME)) return;

      opening = true;
      try {
        if (delaySeconds > 0) await new Promise(function(r) { setTimeout(r, delaySeconds * 1000); });
        
        const cart = await fetchCart();
        await removeGiftsIfNotEligible(cart);
        
        if (!isEligible(cart)) return;

        popup.hidden = false;
        popup.setAttribute("aria-hidden", "false");
        createConfetti();
        
        if (showOnce) setCookie(COOKIE_NAME, "1", cookieDays);
        await initCards();
      } finally {
        opening = false;
      }
    }

    async function initCards() {
      const cards = Array.from(popup.querySelectorAll("[data-gift-product]"));
      if (!cards.length) return;

      setupTabs(popup, cards);

      const cart = await fetchCart();
      const giftInCart = isAnyGiftInCart(cart, giftIds);

      for (var i = 0; i < cards.length; i++) {
        const card = cards[i];
        const handle = card.dataset.giftHandle;
        const pickers = card.querySelector("[data-gift-variant-pickers]");
        const addBtn = card.querySelector("[data-gift-add]");
        const msgEl = card.querySelector("[data-gift-msg]");
        const mediaImg = card.querySelector(".gift-product__media img");

        if (!handle || !pickers || !addBtn) continue;

        const setMsg = function(t) { if (msgEl) msgEl.textContent = t || ""; };
        var selectedId = null;

        if (giftInCart) {
          addBtn.disabled = true;
          setMsg("כבר נבחרה מתנה בסל ✅");
          continue;
        }

        try {
          const product = await getProduct(handle);
          
          buildVariantPickers(product, pickers, msgEl,
            function(id) { selectedId = id; },
            function(variant) {
              if (!mediaImg || !variant || !variant.featured_image || !variant.featured_image.src) return;
              const src = variant.featured_image.src.replace(/\?.*$/, "");
              mediaImg.src = src + "?width=800";
              mediaImg.srcset = "";
            }
          );
        } catch (_) {
          addBtn.disabled = true;
          setMsg("שגיאה בטעינת המוצר");
          continue;
        }

        const newBtn = addBtn.cloneNode(true);
        addBtn.parentNode.replaceChild(newBtn, addBtn);

        (function(btn, getSelectedId, setMessage) {
          btn.addEventListener("click", async function() {
            setMessage("");
            
            try {
              const cart = await fetchCart();
              await removeGiftsIfNotEligible(cart);

              if (!isEligible(cart)) {
                setMessage("צריך להגיע לסכום הסף כדי לקבל מתנה");
                return;
              }

              if (isAnyGiftInCart(cart, giftIds)) {
                btn.disabled = true;
                setMessage("כבר נבחרה מתנה בסל ✅");
                return;
              }

              const varId = getSelectedId();
              if (!varId) {
                setMessage("אנא בחר/י צבע/מידה");
                return;
              }

              btn.disabled = true;
              await addVariantToCart(varId);
              close();

              ["cart:refresh", "cart:updated", "theme:cart:refresh", "theme:cart:updated"]
                .forEach(function(ev) { document.dispatchEvent(new CustomEvent(ev)); });

              const opener = document.querySelector("[aria-controls*='cart'], a[href='/cart']");
              if (opener && opener.click) opener.click();
              
              notifyListeners();
            } catch (_) {
              btn.disabled = false;
              setMessage("שגיאה, נסה שוב");
            }
          });
        })(newBtn, function() { return selectedId; }, setMsg);
      }
    }

    async function update() {
      try {
        const cart = await fetchCart();
        await removeGiftsIfNotEligible(cart);
        
        const eligible = isEligible(cart);
        await maybeAutoOpen(eligible);
        
        if (eligible) ensureGiftFab(popup, openManually);
        else removeGiftFab(popup);
        
        setPrevEligible(eligible);
      } catch (_) {
        removeGiftFab(popup);
        setPrevEligible(false);
      }
    }

    window[LISTENERS_KEY].add(update);
    setTimeout(update, 600);
  }

  popups.forEach(initPopup);
})();
